import {PdsWidget} from './pds-widget';
import {NavItem} from './interfaces/nav-item';
import { PoppableElementFactory } from './poppable-element-factory';
import { PopoverAccessibilityControllerFactory } from './popover-accessibility-controller-factory';
import { PopoverAccessibilityControllerIf } from './interfaces/popover-accessibility-controller-if';
import { pdsI18n } from './pds-i18n';
import {PdsImage} from './interfaces/pds-image';
import {UserMenuPopover} from './interfaces/user-menu-popover';
import {PopoverEngine} from './interfaces/popover-engine';
import {SinglePopoverWidget} from './single-popover-widget';
import { pdsLogger } from './pds-logger';
import {PopperPlacement} from './popper-configuration';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('app-switcher'), 'pds-user-menu.ts');

export class PdsUserMenu extends SinglePopoverWidget {
  is = 'pds-user-menu';

  scopeClass: string;

  // state: 'OPEN' | 'CLOSED';

  userMenuPopoverInstance: UserMenuPopover | undefined;

  //Input
  userNavigation: Array<NavItem>;

  // popoverCreated: boolean;
  //Input
  user: { firstName: string, lastName: string, profilePicture?: PdsImage} | undefined;

  //When the user clicks their name, the user menu pops up
  userMenuOpen = false;

  properties = {
    scopeClass: {
      type: String,
      value: ''
    },
    // state: {
    //   type: String,
    //   value: 'CLOSED'
    // },
    user: {
      value: null //We need a user for the menu to render
    },
    name:  {
      value: null,
      type: String //We construct the id using the name property
    }
  };

  protected popoverAccessibilityController: PopoverAccessibilityControllerIf;
  protected popoverTrigger: HTMLElement;
  protected popoverContentElement: HTMLElement;

  attached(): void {
    super.attached();
    // this.popoverCreated = false;

    // this.createPopoverMenu();

    setTimeout(() => {
      this.verifyNamePresent();
    });
  }

  /**
   * This function may or may not create the popover menu right away.  If it doesn't, it waits until the proper data is
   * there and then creates the popper.
   */
  // createPopoverMenu(): void {
  //   if (!this.popoverCreated &&
  //        this.user != null &&
  //        //Tippy must have the pds-user-menu template rendered to the dom before it can work
  //        //because it takes the menu piece and moves it to the end of the page for rendering later
  //        this.querySelector('#' + this.name + '-user-menu-popover') != null) {
  //     this.popoverAccessibilityController = PopoverAccessibilityControllerFactory.getPopoverAccessibilityControllerInstance();
  //     this.popoverTrigger = <HTMLElement>this.querySelector('#' + this.name + '-user-menu-trigger');
  //     this.popoverContentElement = <HTMLElement>this.querySelector('#' + this.name + '-user-menu-popover');
  //     this.popoverAccessibilityController.setPanelTrigger(this.popoverTrigger);
  //     this.popoverAccessibilityController.setHidePanelCallback(() => { this.hidePanel(); });
  //     this.popoverAccessibilityController.setPanelContainer(this.popoverContentElement);
  //     this.popoverAccessibilityController.addRequiredAccessibilityLabelsToChildTabbableElements();
  //     this.createUserMenuPanel();
  //     this.popoverCreated = true;
  //   } else {
  //     //this gets the main template and listens to it to complete which apparently includes it's children
  //     //That way we ensure that the elements needed have already been added to the DOM.
  //     this.querySelector('.user-menu-main').addEventListener('dom-change', (event): void => {
  //       this.createPopoverMenu();
  //     });
  //   }
  // }

  isRequiredDataDefined(): boolean {
    return this.userNavigation != null;
  }

  getPopoverSelector(): string {
    return '.pds-user-menu-popover';
  }

  getPopoverTriggerSelector(): string {
    return '.pds-user-menu-trigger';
  }

  getListenerSelector(): string {
    return '.pds-user-menu-contents';
  }
  // toggleUserMenu(): void {
  //   this.state = (this.state === 'OPEN') ? 'CLOSED' : 'OPEN';
  // }

  getButtonAriaLabel(state): string {
    return pdsI18n.getText(this.isPopoverShowing ? 'pds|app switcher|Close user menu' : 'pds|app switcher|Open user menu');
  }

  // createUserMenuPanel(): void {
  //   let popoverConfig = PoppableElementFactory.generatePopoverConfig(
  //                       false,
  //                       'bottom-end',
  //                       7000,
  //                       'popover user-menu',
  //                       this.popoverContentElement,
  //                       (instance: PopoverEngine) => { this.onUserMenuHidden(instance); },
  //                       (instance: PopoverEngine) => { this.onUserMenuShown(instance); });
  //   this.userMenuPopoverInstance = <UserMenuPopover>PoppableElementFactory.generatePoppableElement(this.popoverTrigger, popoverConfig, this.is);
  //   if (this.userMenuPopoverInstance != null &&
  //       this.userMenuPopoverInstance.popper != null &&
  //       this.userMenuPopoverInstance.popper.firstChild != null) {
  //     this.userMenuPopoverInstance.popper.classList.add('pds-user-menu');
  //     (<HTMLElement>this.userMenuPopoverInstance.popper.firstChild).classList.add('pds-user-menu');
  //   }
  // }

  onUserMenuHidden(popoverEngineInstance: PopoverEngine): void {
    this.hidePopover();
    this.popoverAccessibilityController.deregisterEventListenerOnPanel('keydown');
  }

  onUserMenuShown(popoverEngineInstance: PopoverEngine): void {
    this.popoverContentElement = popoverEngineInstance.popper;
    this.popoverAccessibilityController.setPanelContainer(this.popoverContentElement);
    this.popoverContentElement.setAttribute('aria-label', pdsI18n.getText('pds|popover|Backwards From First Element'));
    this.popoverAccessibilityController.registerEventListenerOnPanel('keydown');
  }

  // hidePanel(): void {
  //   this.state = 'CLOSED';
  //   if (this.userMenuPopoverInstance != null) {
  //     this.userMenuPopoverInstance.hide();
  //   }
  // }

  getUserInitialsForDisplay(): string {
    let userInitials = '';
    if (this.user != null) {
      if (this.user.firstName != null) {
        userInitials += this.user.firstName.slice(0, 1);
      }

      if (this.user.lastName != null) {
        userInitials += this.user.lastName.slice(0, 1);
      }
    }
    return userInitials;
  }

  hasUserProfilePicture(): boolean {
    return this.user != null && this.user.profilePicture != null;
  }

  userMenuClickHandler(event: Event): void {
    event.preventDefault();

    let target = <HTMLElement & { dataNav: NavItem }>event.target;
    if (!this.pds.utils.is(target, 'a')) {
      target = <HTMLElement & { dataNav: NavItem }>this.pds.utils.getClosest(target, 'a');
    }

    let nav = target.dataNav;
    this.hidePopover();

    if (nav.onUserClick != null) {
      nav.onUserClick(nav, event);
    } else {
      throw `NavItem ${nav.id} did not have onUserClick function defined.`;
    }
  }

  log(message?: any, ...optionalParams: any[]): void {
    log.apply(window, arguments);
  }

  getDefaultAlignment(): PopperPlacement {
    return 'bottom-end';
  }
}
